import React from 'react';
import { DOMAIN } from '@autopass-web/domain';
import { useState, useEffect } from 'react';

import Maintenance from './maintenance';
interface FeatureMaintenanceProps {
  children: React.ReactNode;
}

interface MaintenanceConfigType {
  enabled: boolean;
  title?: string;
  content?: string;
}

const FeatureMaintenance = ({ children }: FeatureMaintenanceProps) => {
  const [maintenanceConfig, setMaintenanceConfig] =
    useState<MaintenanceConfigType | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 2000);

    const fetchMaintenanceConfig = async () => {
      await fetch(`${DOMAIN.MAINTENANCE_URL}/config.json`, {
        signal: controller.signal,
      })
        .then((res) => res.json())
        .then((res) => {
          const data = res.default;

          if (data['all'].enabled) {
            setMaintenanceConfig(data['all']);
          } else if ('web' in data) {
            setMaintenanceConfig(data['web']);
          } else {
            setMaintenanceConfig({ enabled: false });
          }
        })
        .catch((err) => {
          console.error(err);
          setMaintenanceConfig({ enabled: false, title: '', content: '' });
        })
        .finally(() => {
          clearTimeout(timeoutId);
        });
    };
    fetchMaintenanceConfig();
  }, []);

  if (!maintenanceConfig) return null;

  if (maintenanceConfig.enabled) {
    return (
      <Maintenance
        title={maintenanceConfig.title}
        content={maintenanceConfig.content}
      />
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment>{children}</React.Fragment>;
};

export default FeatureMaintenance;
